import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function timePatternValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; 
    }
    
    
    const pattern = /^([1-9]|0[1-9]|1[0-2])([0-5][0-9])$/;
    
    
    if (!pattern.test(control.value)) {
      return { invalidTimeFormat: true };
    }

    return null; 
  };
}

export function itemDatePatternValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    
    if(!formGroup){
      return null;
    }

    const startTime = formGroup.get('startTime')?.value;
    const endTime = formGroup.get('endTime')?.value;
 
    if (!startTime && endTime) {
      return { startTimeRequired: true };
    }
    else if (startTime && !endTime) {
      return { endTimeRequired: true };
    }
 
    return null;
  };


}
